import React from "react";
import { Input, Typography } from "antd";
import { InputContainer, HelperTextStyle } from "./styles";
import { countText, cutTextToLimit } from "../../utils/textLength";

interface InputComponentProps {
	title?: string;
	helperText?: string;
	style?: React.CSSProperties;
	isRequired?: boolean;
	value?: string | number | undefined;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	error?: boolean;
	isDisabled?: boolean;
	size?: "small" | "middle" | "large";
	readonly?: boolean;
	// Shows "count / max" in the field and stops the text at max characters (the limit the backend checks).
	maxLength?: number;
}

const InputComponent = ({
	title,
	helperText,
	style,
	isRequired = false,
	value = "",
	onChange,
	placeholder = "Lütfen giriniz",
	error = false,
	isDisabled,
	size = "large",
	readonly = false,
	maxLength,
}: InputComponentProps) => {
	const status = error ? "error" : undefined;

	return (
		<InputContainer>
			{title &&(
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
					{helperText && (
						<span style={HelperTextStyle}>
							({helperText})
						</span>
					)}
				</Typography.Title>
			)}
			<Input
				size={size}
				style={{ 
					width: "100%",
					height: "40px",
					marginBottom: "10px",
					cursor: readonly ? "not-allowed" : "auto", 
					...style 
				}}
				status={status}
				value={value}
				onChange={onChange}
				disabled={isDisabled}
				placeholder={placeholder}
				readOnly={readonly}
				count={maxLength === undefined ? undefined : {
					show: true,
					max: maxLength,
					strategy: text => countText(text),
					exceedFormatter: (text, { max }) => cutTextToLimit(text, max),
				}}
			/>
		</InputContainer>
	);
};

export default InputComponent;
